<script>
    import { db } from '../../Database.svelte';

    import ReferencesField from '../../Forms/CustomFields/ReferencesField.svelte';
    import {addModal} from '../ModalManager.svelte';
    import LibraryMappingModal from './LibraryMappingModal.svelte';
    import QuestionMappingModal from '../QuestionLibrary/QuestionMappingModal.svelte';
    import {notifier} from '@beyonk/svelte-notifications';

    import QuestionTypes from '../../lib/QuestionTypes';
    import {sortBy} from "lodash-es";

    import Tags from '../Tags.svelte';
    import {clean} from '../../Utilities/Cleaner.svelte';
    import Loader from '../Loader.svelte';

    export let assessment_type;
    export let assessment_control;

    export let control;

    function getLink(ctrl) {
        let library_id = ctrl.id.split(":").slice(0, 2).join(":");

        return `#/questionLibrary/${library_id}/${ctrl.id}`
    }

    async function getLibraryMap(mapping) {
        let item =  await db.get(mapping.id);
        let library = await db.get(mapping.library_id);

        return {
            type: library.name,
            text: item.name
        }
    }

    function assignLibraryMapping(mapping, library_map) {
        addModal(LibraryMappingModal, {
            mapping,
            library_map,
            assessment_type,
            control: $control.details,
            assessment_control
        }).then((m) => {
            assessment_control.library_mappings[library_map._id] = m;
        })
    }

    function getAnswers(answers) {
        let buttons = [];
        for (let btn of Object.values(QuestionTypes[$control.details.question_type].buttons)) {
            if (answers.includes(btn.value)) {
                buttons.push(btn);
            }
        }

        return buttons;
    }

    function getTags(tags) {
        return assessment_type.question_tags.filter(t => tags.includes(t.tag_id));
    }

    function getLibraryMapings(library_map) {
        if (!assessment_control.library_mappings[library_map._id]) return [];

        let mappings = []
        for (let section of assessment_type.report_sections) {
            if (section.library_type == library_map.library_id) {
                let answer_mappings = [];
                if (assessment_control.library_mappings[library_map._id]['answers'][section._id]) {
                    answer_mappings = getAnswers(assessment_control.library_mappings[library_map._id]['answers'][section._id])
                }

                let tag_mappings = [];
                if (assessment_control.library_mappings[library_map._id]['tags'][section._id]) {
                    tag_mappings = getTags(assessment_control.library_mappings[library_map._id]['tags'][section._id])
                }

                mappings.push({
                    section_name: section.section_name,
                    answer_mappings,
                    tag_mappings
                })
            }
        }

        return mappings
    }

    async function getMap(tag_map) {
        let mapping = await db.get(tag_map.id);

        for (let section of assessment_type.report_sections) {
            if (section.section_id == tag_map.section_id) {
                return {
                    type: section.section_name,
                    text: mapping.name
                }
            }
        }

        throw new Error("Section not Found");
    }

    function addAnswerMapping(answer_value) {
        addModal(QuestionMappingModal, {
            assessment_type
        }).then(result => {
            if (!assessment_control.recommendation_map[answer_value]) {
                assessment_control.recommendation_map[answer_value] = [result];
            } else {
                assessment_control.recommendation_map[answer_value] = [...assessment_control.recommendation_map[answer_value], result];
            }
        })
    }

    function removeAnswerMapping(answer_value, answer_map) {
        assessment_control.recommendation_map[answer_value] = assessment_control.recommendation_map[answer_value].filter(map => map != answer_map);
        saveControl();
    }

    function addTagMapping(tag) {
        addModal(QuestionMappingModal, {
            assessment_type
        }).then(result => {
            if (!assessment_control.tag_mapping[tag.tag_id]) {
                assessment_control.tag_mapping[tag.tag_id] = []
            }
            assessment_control.tag_mapping[tag.tag_id] = [...assessment_control.tag_mapping[tag.tag_id], result];
        });
    }

    function removeTagMapping(tag, tag_map) {
        assessment_control.tag_mapping[tag.tag_id] = assessment_control.tag_mapping[tag.tag_id].filter(t => t != tag_map);
    }

    function saveControl() {
        assessment_type.model.saveControl(assessment_control).then(() => notifier.success("Mapping Updated"))
    }

</script>

<Loader loading={!$control} fullscreen={false}>
    <div class="buttons is-right save">
        <a href="{getLink($control)}" class="button is-info">
            Edit Library Control
        </a>
        <button class="button is-success" on:click={saveControl}>
            Save Control Mappings
        </button>
    </div>
    <div class="columns">
        <div class="field column is-narrow">
            <label class="label" for="input_control_number">Control Number</label>
            <div class="control">
                <input type="text" class="input title is-4" value={$control.details.control_number} id="input_control_number" readonly=true disabled=true>
            </div>
        </div>
        <div class="field column">
            <label class="label" for="input_control_name">Control Title</label>
            <div class="control">
                <input type="text" class="input title is-4 disabled" value={$control.details.name} id="input_control_name" readonly=true disabled=true>
            </div>
        </div>
    </div>
    <div class="columns">
        <div class="column flex">
            <h3 class="title is-4">Control Text</h3>
            <textarea class="textarea is-size-4 flex-grow" value={$control.details.text} disabled=true></textarea>
        </div>
        <div class="column">
            <h3 class="title is-4">Control Level</h3>
            <div class="select is-fullwidth">
                <select value={$control.details.level} disabled=true>
                    <option value="1">Level 1</option>
                    <option value="2">Level 2</option>
                    <option value="3">Level 3</option>
                    <option value="4">Level 4</option>
                    <option value="5">Level 5</option>
                </select>
            </div>
            <h3 class="title is-4">Answer Type</h3>
            <div class="select is-fullwidth">
                <select value={$control.details.question_type} disabled=true>
                    <option value="implementation_status">Implementation Status</option>
                    <option value="yes_no">Yes/No</option>
                    <option value="free_text">Free Text</option>
                </select>
            </div>
            <h3 class="title is-4">References</h3>
            <ReferencesField value={$control.details.references} disabled=true />

            <h3 class="title is-4">Topic Tags</h3>
            <div class="field is-grouped- is-grouped-multiline">
                <div class="control">
                    <Tags tags={$control.details.topic_tags} addKeys={[9,13]} disable={true} />
                </div>
            </div>
        </div>
    </div>

    <div class="columns flex-grow">
        <div class="column flex-column">
            <h3 class="title is-4">Supplemental Guidance</h3>
            <div class="is-size-5 flex-grow">
                <div class="guidance">
                    {@html clean($control.details.guidance)}
                </div>
            </div>
        </div>

        <div class="column">
            <h1 class="title is-4">Library Mappings</h1>

            <table class="table is-fullwidth">
                <thead>
                    <tr>
                        <th>Mapping Type</th>
                        <th>Mapping Value</th>
                        <th>Section Mapping</th>
                    </tr>
                </thead>

                <tbody>
                    {#each [...$control.library_mappings] as library_map (library_map.details._id)}
                        <tr>
                            {#await getLibraryMap(library_map.details)}
                            <td colspan="3">
                                Loading...
                            </td>
                            {:then mapping}
                                <td class="is-v-centered">
                                    {mapping.type}
                                </td>
                                <td class="prewrap is-v-centered">{mapping.text}</td>
                                <td>
                                    <table class="table">
                                        <tr>
                                            <th>Report Section</th>
                                            <th>Mappings</th>
                                        </tr>
                                        {#each getLibraryMapings(library_map.details, assessment_control) as mapping}
                                        <tr>
                                            <td>{mapping.section_name}</td>
                                            <td>
                                                <div class="buttons">
                                                    {#each mapping.answer_mappings as button}
                                                        <span class="button {button.color} is-light">{button.label}</span>
                                                    {/each}
                                                </div>
                                                {#each mapping.tag_mappings as tag (tag.tag_id)}
                                                    <span class="tag is-{tag.color_class} is-light">{tag.name}</span>
                                                {/each}
                                            </td>
                                        </tr>
                                        {/each}
                                        <tr>
                                            <td colspan="2">
                                                <button class="is-pulled-right button is-primary" on:click={() => assignLibraryMapping(mapping, library_map.details)}>Assign Mapping</button>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            {:catch e}
                                <td colspan="2">Mapping No Longer Exists ({e})</td>
                            {/await}
                        </tr>
                    {/each}
                </tbody>
            </table>

            <h1 class="title is-4">Control Mappings</h1>

            <h3 class="title is-5">Finding Mapping</h3>
                    <table class="table is-striped is-fullwidth">
                        <thead>
                            <tr>
                                <th>Answer</th>
                                <th>Mappings</th>
                            </tr>
                        </thead>
                        <tbody>
                            {#if $control.details.question_type != "free_text"}
                                {#each sortBy(Object.values(QuestionTypes[$control.details.question_type].buttons), ["order"]) as btn (btn.label)}
                                    <tr>
                                        <td>{btn.label}</td>
                                        <td>
                                            <table class="table is-fullwidth">
                                                <thead>
                                                    <tr>
                                                        <th>Mapping Type</th>
                                                        <th>Mapping Value</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tfoot>
                                                    <tr>
                                                        <td colspan=3>
                                                            <button class="button is-pulled-right is-info" on:click={() => addAnswerMapping(btn.value)}>Add Mapping</button>
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                                <tbody>
                                                    {#each assessment_control.recommendation_map[btn.value] || [] as answer_map}
                                                        <tr>
                                                            {#await getMap(answer_map)}
                                                            <td colspan="3">
                                                                Loading...
                                                            </td>
                                                            {:then mapping}
                                                                <td>
                                                                    {mapping.type}
                                                                </td>
                                                                <td class="prewrap">
                                                                    {mapping.text}
                                                                </td>
                                                                <td>
                                                                    <button class="button is-danger" on:click={() => removeAnswerMapping(btn.value, answer_map)}>Delete</button>
                                                                </td>
                                                            {:catch}
                                                                <td colspan="2">Mapping No Longer Exists</td>
                                                                <td><button class="button is-danger" on:click={() => removeAnswerMapping(btn.value, answer_map)}>Delete</button></td>
                                                            {/await}
                                                        </tr>
                                                    {/each}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                {/each}
                            {:else}
                                    <tr>
                                        <tr>
                                            <td>Any</td>
                                            <td>
                                                <table class="table is-fullwidth">
                                                    <thead>
                                                        <tr>
                                                            <th>Mapping Type</th>
                                                            <th>Mapping Value</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tfoot>
                                                        <tr>
                                                            <td colspan=3>
                                                                <button class="button is-pulled-right is-info" on:click={() => addAnswerMapping("text")}>Add Mapping</button>
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                    <tbody>
                                                        {#each assessment_control.recommendation_map["text"] || [] as answer_map}
                                                            <tr>
                                                                {#await getMap(answer_map)}
                                                                <td colspan="3">
                                                                    Loading...
                                                                </td>
                                                                {:then mapping}
                                                                    <td>
                                                                        {mapping.type}
                                                                    </td>
                                                                    <td class="prewrap">{mapping.text}</td>
                                                                    <td>
                                                                        <button class="button is-danger" on:click={() => removeAnswerMapping("text", answer_map)}>Delete</button>
                                                                    </td>
                                                                {:catch}
                                                                    <td colspan="2">Mapping No Longer Exists</td>
                                                                    <td><button class="button is-danger" on:click={() => removeAnswerMapping("text", answer_map)}>Delete</button></td>
                                                                {/await}
                                                            </tr>
                                                        {/each}
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                            {/if}
                        </tbody>
                    </table>
                    <h3 class="title is-5">Tag Mapping</h3>
                    <table class="table is-striped is-fullwidth">
                        <thead>
                            <tr>
                                <th>Tag</th>
                                <th>Mappings</th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each assessment_type.question_tags as tag (tag.tag_id)}
                            <tr>
                                <td class="has-background-{tag.color_class}">
                                    {tag.name}
                                </td>
                                <td>
                                    <table class="table is-fullwidth">
                                        <thead>
                                            <tr>
                                                <th>Mapping Type</th>
                                                <th>Mapping Value</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tfoot>
                                            <tr>
                                                <td colspan=3>
                                                    <button class="button is-pulled-right is-info" on:click={() => addTagMapping(tag)}>Add Mapping</button>
                                                </td>
                                            </tr>
                                        </tfoot>
                                        <tbody>
                                            {#each assessment_control.tag_mapping[tag.tag_id] || [] as tag_map}
                                                <tr>
                                                    {#await getMap(tag_map)}
                                                    <td colspan="3">
                                                        Loading...
                                                    </td>
                                                    {:then mapping}
                                                        <td>
                                                            {mapping.type}
                                                        </td>
                                                        <td class="prewrap">{mapping.text}</td>
                                                        <td>
                                                            <button class="button is-danger" on:click={() => removeTagMapping(tag, tag_map)}>Delete</button>
                                                        </td>
                                                    {:catch}
                                                        <td colspan="2">Mapping No Longer Exists</td>
                                                        <td><button class="button is-danger" on:click={() => removeTagMapping(tag, tag_map)}>Delete</button></td>
                                                    {/await}
                                                </tr>
                                            {/each}
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            {/each}
                        </tbody>
                    </table>
        </div>
    </div>
</Loader>